// Palette codes from https://fluentsite.z22.web.core.windows.net/0.54.0/color-palette
export const TeamsColors = {
  // brand
  brand200: '#E2E2F6',
  brand450: '#7F85F5',

  // For fixing https://dev.azure.com/yammer/engineering/_workitems/edit/224364
  // we are changing the following brand color until FUI9
  brand500: '#8B8CC5',
  brand600: '#6264A7',
  brand700: '#4F52B2',
  brand800: '#464775',

  // FUI9 brand tokens we can't find the source color names for
  fui9ColorBrandBackground2TeamsThemeLight: '#E8EBFA',
  fui9ColorBrandBackground2TeamsThemeDark: '#2F2F4A',
  fui9ColorBrandBackground2HoverTeamsThemeLight: '#DCE0FA',
  fui9ColorBrandBackground2HoverTeamsThemeDark: '#383966',

  // gray
  gray50: '#FAF9F8',
  gray100: '#F0F0F0',
  gray150: '#EDEBE9',
  gray200: '#E1DFDD',
  gray500: '#484644',
  gray550: '#3B3A39',
  gray600: '#323131',
  gray650: '#2D2C2C',
  gray750: '#252423',

  // orange
  orange300: '#E97548',

  // red
  red200: '#F9526B',
};

// These colors are currently in use by Teams but not part of their future palette.
export const TeamsLegacyColors = {
  gray70: '#F5F5F5', // background, light mode
  gray870: '#1F1F1F', // background, dark mode
};

// These colors are not part of the Teams palette and used only by Yammer.
export const YammerColors = {
  brand70: '#E9EAF6', // Question, light mode
  brand350: '#B2B5FF', // link in question
  brand550: '#3D3E66', // Question, dark mode

  gray860: '#1C1B1B',
};
